<template>
  <div :class="classes">
    <div class="c-success__title">
      <svg class="c-success__icon" fill="none" viewBox="0 0 38 38">
        <defs />
        <circle cx="19.5" cy="19.5" r="14.5" fill="#fff" />
        <path
          fill="#63C667"
          d="M19 0C8.52 0 0 8.52 0 19s8.52 19 19 19 19-8.52 19-19S29.48 0 19 0zm10.62 14L17.48 26.05c-.72.71-1.86.76-2.62.05l-6.43-5.86a1.93 1.93 0 01-.14-2.67c.71-.76 1.9-.8 2.66-.1l5.1 4.67L26.9 11.3a1.9 1.9 0 012.72 0 1.9 1.9 0 010 2.71z"
        />
      </svg>
      <span v-html="content.title" />
    </div>
    <div class="c-success__text" v-html="content.text" />
  </div>
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  name: "c-success",
  mixins: [contentComponent],
};
</script>

<style lang="scss" scoped>
.c-success {
  background: #fff;
  font-weight: 300;
  padding: 2rem;
  border-radius: 0.5rem;
  max-width: 90%;
  font-size: 1.125rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  @include media-breakpoint-down(xl) {
    font-size: 1rem;
    padding: 1.5rem;
  }

  @include media-breakpoint-down(lg) {
    font-size: 0.75rem;
    padding: 1.25rem;
  }

  &__icon {
    width: 38px;
    height: 38px;
    margin: 0 1rem 0 0;

    @include media-breakpoint-down(xl) {
      width: 2rem;
      margin: 0 0.75rem 0 0;
    }
    @include media-breakpoint-down(lg) {
      width: 1.5rem;
      margin: 0 0.5rem 0 0;
    }
  }
  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.125rem;
    font-weight: bold;

    @include media-breakpoint-down(xl) {
      font-size: 1rem;
    }

    @include media-breakpoint-down(lg) {
      font-size: 0.75rem;
    }
  }
  &__text {
    margin: 1rem 0 0;
    text-align: center;

    @include media-breakpoint-down(xl) {
      margin-top: 0.75em;
    }
    @include media-breakpoint-down(lg) {
      margin-top: 0.5em;
    }
  }
}
</style>
